//^ Groups

//& Kombus Groups
export const treeGroupsDataKombusKornik = [];
export const treeGroupsDataSrodaWlkp = [];
export const treeGroupsKombusZTM = [];

//& PKS Groups
export const treeGroupsDataPKS = [];

//& TA Groups
export const treeGroupsDataTA_MDT = [];
export const treeGroupsDataTA_COMB = [];
export const treeGroupsDataTA_SW = [];
export const treeGroupsDataTA_Doral = [];
export const treeGroupsDataTA_MiamiSprings = [];
export const treeGroupsDataTA_SmallCities = [];
export const treeGroupsDataTA_FortLauderdale = [];
export const treeGroupsDataTA_PompanoBeach = [];
export const treeGroupsDataTA_BCT = [];

//& Rokbus
export const treeRokbus = [];

//& KiedyBusDyspozytor
export const treeKiedyBusDyspozytor = [];
